<template>
	<v-app style="background-color: #F0F5F7 !important;">
		<!-- <div class="ribbon">
            <h2 class="bold white-text">USKORO</h2>
        </div> -->
		<div class="w-100 top-header w-100 hidden-sm-and-down print-hide">
			<v-container class="content-wrap flex-between" dark>
				<p class="mb-0">It always seems impossible until it's done.</p>
				<div class="social flex-center" dark>
					<a href="https://www.facebook.com/skole.sum.ba/" target="_blank" class="mr-4">
						<v-icon class="mr-4">fab fa-facebook-f</v-icon>
					</a>
					<a href="https://www.instagram.com/skole.sum.ba/" target="_blank" class="mr-4">
						<v-icon class="mr-4">fab fa-instagram</v-icon>
					</a>
					<a href="https://www.youtube.com/channel/UCgqbhSxPBuVGfAEEnxEk2cQ" target="_blank">
						<v-icon>fab fa-youtube</v-icon>
					</a>
				</div>
			</v-container>
		</div>
		<nav class="print-hide">
			<v-app-bar fixed app class="flex-center" :height="navHeight" :color="navColor" style="z-index: 20;">
				<v-container :class="{ 'nav-padding': navPadding }" ref="navbar-content"
					class="content-wrap flex-center px-0" style="position:relative;">
					<div class="flex-center">
						<a href="/">
							<img v-if="this.$route.fullPath == '/sumtv'" :src="require('@/assets/img/sum-tv-blue.svg')" :height="logoHeight" />
							<img v-else :src="require('@/assets/img/logo.svg')" :height="logoHeight" />
						</a>
						<v-divider class="hidden-md-and-down mx-6" vertical></v-divider>
						<div class="flex-left flex-column pt-6 hidden-md-and-down">
							<p ref="nav-text" class="text--disabled mb-1 text-left w-100 overline">
								BROJ ONLINE <br>
								NASTAVNOG SADRŽAJA
							</p>
							<p class="blue-text title bold w-100 text-left">
								{{ contentCount }}
							</p>
						</div>
					</div>
					<v-spacer></v-spacer>
					<v-toolbar-items v-if="!searchBar" class="hidden-sm-and-down" ref="nav-items-1">
						<v-btn depressed class="font-weight-light text--primary text-capitalize nav-link px-6 py-5"
							active-class="nav-active" text to="/raspored">Raspored
						</v-btn>
					</v-toolbar-items>
					<v-toolbar-items v-if="!searchBar && isHome" class="hidden-sm-and-down" ref="nav-items-1">
						<v-btn depressed class="font-weight-light text--primary text-capitalize nav-link px-6 py-5"
							v-for="item in menu" :key="item.id" active-class="nav-active" text
							@click="$vuetify.goTo(item.element)">{{ item.title }}
						</v-btn>
					</v-toolbar-items>
					<v-toolbar-items v-if="!searchBar && !isHome" class="hidden-sm-and-down" ref="nav-items-1">
						<v-btn depressed class="font-weight-light text--primary text-capitalize nav-link px-6 py-5"
							v-for="item in menu" :key="item.id" active-class="nav-active" text :to="item.url">
							{{ item.title }}
						</v-btn>
					</v-toolbar-items>
					<v-toolbar-items v-if="!searchBar" class="hidden-sm-and-down" ref="nav-items-1">
						<v-btn depressed class="font-weight-light text--primary text-capitalize nav-link px-6 py-5"
							active-class="nav-active" text href="https://skole.sum.ba/gsuite">G-Suite
						</v-btn>
					</v-toolbar-items>
					<v-toolbar-items v-if="!searchBar" class="hidden-sm-and-down" ref="nav-items-1">
						<v-btn depressed class="font-weight-light text--primary text-capitalize nav-link px-6 py-5"
							active-class="nav-active" text href="https://skole.sum.ba/skolarac">Školarac
						</v-btn>
					</v-toolbar-items>
					<v-toolbar-items v-if="!searchBar" class="hidden-sm-and-down" ref="nav-items-1">
						<v-btn depressed class="font-weight-light text--primary text-capitalize nav-link px-6 py-5"
							active-class="nav-active" text to="/nastavnik">Nastavnik
						</v-btn>
					</v-toolbar-items>
					<v-toolbar-items v-if="!searchBar" class="hidden-sm-and-down" ref="nav-items-1">
						<v-btn depressed class="font-weight-light text--primary text-capitalize nav-link px-6 py-5"
							active-class="nav-active" text href="https://skole.sum.ba/skole">Škole
						</v-btn>
					</v-toolbar-items>
					<v-toolbar-items v-if="!searchBar" class="hidden-sm-and-down" ref="nav-items-1">
						<v-btn depressed class="font-weight-light text--primary text-capitalize nav-link px-6 py-5"
							active-class="nav-active" text href="https://skole.sum.ba/kontakt">Kontakt
						</v-btn>
					</v-toolbar-items>
					<v-toolbar-items v-if="!searchBar" class="hidden-sm-and-down" ref="nav-items-2">
						<v-btn depressed color="#094776"
							class="text-capitalize white-text font-weight-medium prijava nav-link ml-5 px-10 py-4"
							to="/sumtv">
							SUM TV
						</v-btn>
					</v-toolbar-items>
					<v-toolbar-items v-if="searchBar" style="position:absolute; right:120px;" ref="search-input">
						<v-text-field label="Pretraži" v-model="search"  @keyup.enter.native="getSearch" outlined required class="mt-8"></v-text-field>
					</v-toolbar-items>
					<v-toolbar-items class="hidden-sm-and-down">
						<v-icon v-if="!searchBar" class="ml-6 pa-3 search-btn" @click="activateSearch">search
						</v-icon>
						<v-icon v-if="searchBar" class="ml-6 pa-3 search-btn" @click="activateSearch">clear
						</v-icon>
					</v-toolbar-items>
					<v-app-bar-nav-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-app-bar-nav-icon>
				</v-container>
			</v-app-bar>
			<v-navigation-drawer style="z-index: 300; position:fixed; top:0; left:0; overflow-y:scroll;"
				v-model="drawer" temporary absolute width="300" id="drawer" class="nav-drawer">
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title class="title">
							<v-img :src="require('@/assets/img/logo.svg')" width="150"></v-img>
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-divider></v-divider>
				<v-list class="mt-2" dense nav>
					<v-list-item>
						<v-list-item-content>
							<v-text-field label="Pretraži" v-model="search"  @keyup.enter.native="getSearch" required outlined></v-text-field>
						</v-list-item-content>
					</v-list-item>
					<v-list-item to="/">
						<v-list-item-content>
							<v-list-item-title class="font-weight-light text--primary">Početna</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item to="/raspored">
						<v-list-item-content>
							<v-list-item-title class="font-weight-light text--primary">Raspored</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<div v-if="isHome">
						<v-list-item v-for="item in menu" :key="item.id"
							@click="$vuetify.goTo(item.element); drawer = false;">
							<v-list-item-content>
								<v-list-item-title class="font-weight-light text--primary">{{ item.title }}
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</div>
					<div v-else>
						<v-list-item v-for="item in menu" :key="item.id" :to="item.url">
							<v-list-item-content>
								<v-list-item-title class="font-weight-light text--primary">{{ item.title }}
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</div>
					<v-list-item href="https://skole.sum.ba/gsuite">
						<v-list-item-content>
							<v-list-item-title class="font-weight-light text--primary">G-Suite</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item href="https://skole.sum.ba/skolarac">
						<v-list-item-content>
							<v-list-item-title class="font-weight-light text--primary">Školarac</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<div>
						<v-list-item to="/nastavnik">
							<v-list-item-content>
								<v-list-item-title class="font-weight-light text--primary">Nastavnik</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</div>
					<div>
						<v-list-item href="https://skole.sum.ba/skole">
							<v-list-item-content>
								<v-list-item-title class="font-weight-light text--primary">Škole</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</div>
					<div>
						<v-list-item href="https://skole.sum.ba/kontakt">
							<v-list-item-content>
								<v-list-item-title class="font-weight-light text--primary">Kontakt</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</div>
					<v-list-item to="/sumtv">
						<v-list-item-content>
							<v-list-item-title class="font-weight-light text--primary">SUM TV</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-divider class="my-5"></v-divider>
					<v-list-item>
						<v-list-item-content>
							<div class="flex-left social-mobile">
								<a href="https://www.facebook.com/skole.sum.ba/" target="_blank" class="mr-4">
									<v-icon class="mr-4">fab fa-facebook-f</v-icon>
								</a>
								<a href="https://www.instagram.com/skole.sum.ba/" target="_blank" class="mr-4">
									<v-icon class="mr-4">fab fa-instagram</v-icon>
								</a>
								<a href="https://www.youtube.com/channel/UCgqbhSxPBuVGfAEEnxEk2cQ" target="_blank">
									<v-icon>fab fa-youtube</v-icon>
								</a>
							</div>
						</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-content>
							<p ref="nav-text" class="caption text--disabled mb-1 text-left w-100">
								BROJ ONLINE <br>
								NASTAVNOG SADRŽAJA
							</p>
							<p class="blue-text title bold w-100 text-left">
								{{ contentCount }}
							</p>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-navigation-drawer>
		</nav>
		<!-- <v-container class="content-wrap pt-10">
			<router-link to="/">
				<LogoBlue></LogoBlue>
			</router-link>
		</v-container> -->
		<v-content class="main-wrap pa-0">
			<div class="mobile-header hidden-md-and-up pa-3 w-100 print-hide" dark>
				<p class="mb-0 w-100">It always seems impossible until it's done.</p>
			</div>
			<router-view />
		</v-content>
		<v-container fluid class="flex-center px-10">
			<v-divider class="divider"></v-divider>
		</v-container>
		<div class="footer pa-4">
			<p class="ma-0 text--secondary font-weight-light">
				&copy; Copyright <span class="text--primary bold"><a href="https://sumit.sum.ba" target="_blank"
						class="footer-link blue-text">SUMIT</a></span> 2020
			</p>
		</div>
	</v-app>
</template>

<script>

import LogoBlue from './components/LogoBlue'

export default {
    name: "App",
    components: {
        LogoBlue,
    },
    data() {
        return {
            colorNavbar: false,
            lastScrollPosition: 0,
            drawer: null,
            navColor: "transparent",
            navHeight: 150,
            logoHeight: 70,
            searchBar: false,
            contentCount: null,
			navPadding: true,
			search: '',
            menu: [
                {
                    "id": 1,
                    "title": "Lekcije",
                    "element": "#lekcije",
                    "url": "/lekcije",
                },
                // {
                //     "id": 3,
                //     "title": "G-Suite",
                //     "element": "#gsuite",
                //     "url": "/gsuite",
                // },
                // {
                //     "id": 4,
                //     "title": "Novosti",
                //     "element": "#novosti",
                //     "url": "/novosti",
				// }
            ],
        }
    },
    computed: {
        isHome: function () {
            if (this.$route.fullPath == '/') {
                return 1
            } else {
                return 0;
            }
        },
    },
    created() {
        skoleApi.get('/sadrzaji/statistika').then(response => {
            if (response.status === 200) {
                this.contentCount = response.data.content_count;
            } else {
                this.contentCount = "Greška";
            }
        })
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll);
		this.$store.dispatch('getGrades')
    },
    methods: {
        activateSearch() {
            if (this.searchBar == false) {
                this.searchBar = true;
            } else {
                this.searchBar = false;
            }
        },
        onScroll() {
            if (window.scrollY <= 50 && window.innerWidth > 991) {
                this.navColor = "transparent";
                this.navHeight = 150;
                this.logoHeight = 70;
                this.$refs["nav-text"].classList.remove("shrink");
                this.navPadding = true;

            } else {
                this.navColor = "white";
                this.navHeight = 100;
                this.logoHeight = 40;
                this.navPadding = false;
                if (this.$refs["nav-text"])
                    this.$refs["nav-text"].classList.add("shrink");
            }
		},
		getSearch(){
			this.$router.push('/pretraga?search=' + this.search)
			this.search = ''
			this.searchBar = false
		}
    },
}
</script>

<style lang="scss">
@import "assets/styles/app";

a {
	font-weight: 500;
}

.letter-spacing-none {
	letter-spacing: 0 !important;
}

.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
	color: #dee7ea !important;
	;
}

h2 {
	font-weight: 500 !important;
}

//RIBBON
.ribbon {
	z-index: 20;
	padding: 10px;
	background-color: red;
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	width: 400px;
	top: 50px;
	right: -135px;
	transform: rotate(45deg);

	h2 {
		letter-spacing: 2px;
	}
}

.top-header {
	z-index: 21;
	background-color: #094776;

	div {
		p {
			color: rgba(255, 255, 255, .60);
		}
	}
}

.mobile-header {
	position: fixed;
	z-index: 21;
	top: 100px;
	background-color: #094776;
	p {
		color: rgba(255, 255, 255, .60);
	}
}

.nav-padding {
	padding-top: 90px !important;
}

@media(max-width: 991px) {
	.nav-padding {
		padding-top: 0 !important;
	}
}

.social {
	a {
		i {
			transition: .4s ease;
			color: rgba(255, 255, 255, .60) !important;
		}

		transition: .4s ease;
		text-decoration: none;

		&:hover {
			i {
				transition: .4s ease;
				color: rgb(255, 255, 255) !important;
			}
		}
	}
}

.social-mobile {
	a {
		text-decoration: none;
	}
}

body {
	margin: 0;
	background-color: #F0F5F7 !important;
	overflow-x: hidden !important;
}

* {
	font-family: 'Inter', sans-serif;
}

.content-wrap {
	min-width: 90% !important;
	max-width: 1300px !important;
}

.v-toolbar__content {
	width: 100% !important;
}

.show {
	animation: fade-in .5s ease forwards;
}

.hide {
	animation: fade-out .5s ease forwards;
}

@keyframes fade-out {
	from {
		opacity: 1;
		pointer-events: none;
	}

	to {
		opacity: 0;
	}
}

@keyframes fade-in {
	from {
		opacity: 0;
		pointer-events: all;
	}

	to {
		opacity: 1;
	}
}

.w-100 {
	width: 100% !important;
}

.flex-center {
	display: flex;
	justify-content: center;
	align-items: center;
}

.flex-column {
	flex-direction: column;
}

.flex-between {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.flex-left {
	display: flex;
	justify-content: flex-start;
	align-items: center;
}

.flex-top {
	display: flex;
	justify-content: center;
	align-items: flex-start;
}

.transparent {
	background-color: transparent !important;
	box-shadow: none !important;
}

.nav-link {
	border-radius: 30px !important;
	color: rgba(0, 0, 0, 0.6) !important;
	letter-spacing: 0 !important;

	&:hover {
		background: none !important;
	}
}

.prijava {
	border-radius: 30px !important;
	transition: .4s ease;

	&:hover {
		background-color: #065896 !important;
		transition: .4s ease;
	}
}

.btn,
input,
.navbar-toggler {
	&:focus {
		outline: none;
		box-shadow: none;
	}
}

.shrink {
	font-size: 10px;
}

.bold {
	font-weight: 700 !important;
}

.thin {
	font-weight: 400;
}

.white-text {
	color: #FFF !important;
}

.dark-text {
	color: #212121;
}

.blue-text {
	color: #094776 !important;
}

.gray-text {
	color: #A1A1A1;
}

.search-btn {
	border: 1px solid #DEE7EA;
	border-radius: 50%;
}

@media(max-width: 960px) {

	header,
	.v-toolbar__content {
		height: 100px !important;
		background-color: #FFF !important;
	}
}

.footer {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.footer-link {
	text-decoration: none;
	font-weight: 500;
}

.footer-link:hover {
	text-decoration: underline;
	font-weight: 500;
}

.my-alert {
	background-color: rgba(0, 128, 128, 0.15);
	border-left: 4px solid teal;
	border-radius: 4px;

	div {
		p {
			color: rgb(0, 128, 128)
		}
	}
}

@media(max-width: 768px) {
	.my-alert {
		flex-direction: column;

		.v-icon {
			display: none !important;
		}

		.moodle-btn {
			width: 100% !important;
			margin-top: 15px;
		}
	}
}

</style>
